/* Olilu welcome offer: the scratch card (snippets/welcome-tissue.liquid, styles in section-welcome.css).
   Opens once by itself: after 20s of visible time, on the second page view of a visit, or on exit intent on desktop
   (the mouse leaving through the top of the window). collection.landing waits 30s before any of these. Product pages
   never open it by themselves: there the same moment only shows the "Scratch & unlock" pill.
   Never for customers with orders or anyone with the olilu_subscribed cookie (set by a claim).
   Closing it before claiming (x, Esc, the backdrop, "No thanks") shrinks it to the pill and stops it opening by itself
   for 30 days; the pill reopens it where they left off. The pill's own x hides the pill for 7 days.
   Add ?welcome=1 or #welcome to a page address to open it whatever the cookies say (owner preview).
   Flow: scratch the foil (or "Tap to reveal") -> "A gift for you" (never what the gift is) -> by itself after a moment,
   "You've unlocked 10% off": email (+ mobile) -> "Check your inbox", with the code shown too and applied with
   /discount/CODE. A light scratch is enough: a tenth of the foil, or one swipe across half the card's width.
   Sign-ups go to Shopify (a POST to /contact) and, once its keys are filled in, Klaviyo: the email list (whose welcome
   email sends the code) and the profile properties welcome_code, welcome_gift and signup_source.
   "Check your inbox" only shows when the theme says the Klaviyo welcome email is switched on (data-mail) AND Klaviyo
   accepted this sign-up; otherwise (an ad blocker, no signal) the done step just says "Your gift is ready".
   Until Klaviyo is set up Shopify is the only record, so if its bot check answers the POST the form is sent the ordinary
   way (the shopper answers the check) and the code shows when Shopify brings them back with ?customer_posted=true. */
(function () {
  'use strict';
  var O = window.Olilu;
  if (!O) return;
  var cfg = O.cfg || window.oliluConfig || {};

  var DAY = 864e5;
  var KEY_CLOSED = 'olilu_welcome_closed';  // closed without claiming: no automatic opening for 30 days
  var KEY_STATE = 'olilu_welcome';          // {step: 'card' | 'claim', min (minimised at), done}
  var KEY_VIEWS = 'olilu_pv';
  var KEY_PENDING = 'olilu_welcome_pending'; // {code, t}: sent through Shopify's bot check, waiting to come back
  var COOKIE = 'olilu_subscribed';
  var PILL_OFF = 'olilu_welcome_pill_off';
  var BRUSH_R = 30;         // brush radius in px
  var CLEAR_AT = 0.1;       // share of the foil scratched away that reveals the gift...
  var SPAN_AT = 0.5;        // ...or one swipe reaching across this share of the card's width
  var HOLD_MS = 900;        // the foil fades (.2s), then "A gift for you" stays this long in all before the email step
  var CELL = 8;             // grid used to measure how much has been scratched
  var KLAVIYO_REVISION = '2026-07-15';
  var DIAL = { GB: '44', IE: '353', US: '1', CA: '1', AU: '61', NZ: '64', FR: '33', DE: '49', NL: '31', BE: '32', ES: '34', IT: '39', PT: '351', CH: '41', AT: '43', DK: '45', SE: '46', NO: '47' };

  /* ---------- Storage (every access guarded: private windows and blocked storage throw) ---------- */
  function storage(type) { try { return window[type] || null; } catch (e) { return null; } }
  var local = storage('localStorage'), session = storage('sessionStorage');
  function get(s, k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function put(s, k, v) { try { if (s) s.setItem(k, v); } catch (e) { /* ignore */ } }
  function drop(s, k) { try { if (s) s.removeItem(k); } catch (e) { /* ignore */ } }
  function readState() {
    try { var v = JSON.parse(get(local, KEY_STATE) || '{}'); return v && typeof v === 'object' ? v : {}; } catch (e) { return {}; }
  }
  function readPending() {
    try { var p = JSON.parse(get(session, KEY_PENDING) || 'null'); if (p && Date.now() - p.t < 30 * 60 * 1000) return p; } catch (e) { /* ignore */ }
    drop(session, KEY_PENDING);
    return null;
  }

  function hasCookie(name) {
    try { return document.cookie.split(/;\s*/).some(function (c) { return c.indexOf(name + '=') === 0; }); } catch (e) { return false; }
  }
  function setCookie(name, value, days) {
    try {
      document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + Math.round(days * 86400) + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) { /* ignore */ }
  }
  function closedRecently() {
    var t = Number(get(local, KEY_CLOSED));
    return !!t && Date.now() - t < 30 * DAY;
  }
  function rootUrl() {
    var r = (cfg.routes && cfg.routes.root) || '/';
    return r.slice(-1) === '/' ? r : r + '/';
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  // Never leave anyone waiting on a slow network: carry on after 6s
  function settle(jobs) { return Promise.race([Promise.all(jobs), wait(6000)]); }

  // A mobile number in E.164 (+447700900123), '' when empty, null when it can't be a phone number
  function e164(raw, iso) {
    var v = String(raw || '').trim();
    if (!v) return '';
    var intl = /^(\+|00)/.test(v);
    var d = v.replace(/\D/g, '');
    if (/^00/.test(v)) d = d.slice(2);
    if (intl) d = d.replace(/^(44|353|61|64|33|49|31|32|41|43)0/, '$1'); // +44 (0)7700 900123
    else {
      var dial = DIAL[iso] || '44';
      if (dial === '44' && /^44\d{10}$/.test(d)) {
        // typed with the country code but no +
      } else {
        if (dial === '1') { if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1); }
        else if (iso !== 'IT') d = d.replace(/^0/, ''); // the trunk 0 (07700 900123 -> 7700 900123)
        d = dial + d;
      }
    }
    if (!/^[1-9]\d{7,14}$/.test(d)) return null;
    if (/^44/.test(d) && !/^447\d{9}$/.test(d)) return null; // UK mobiles only (07...), texts can't reach a landline
    if (/^1/.test(d) && d.length !== 11) return null;
    return '+' + d;
  }

  O.ready('[data-welcome]', function (el) {
    var tpl = el.querySelector('[data-welcome-tpl]');
    if (!tpl || !('content' in tpl)) return;

    function attr(k) { return el.getAttribute('data-' + k) || ''; }
    var pill = document.getElementById('WelcomePill');
    var pillBtn = pill && pill.querySelector('[data-pill-open]');
    var auto = attr('auto') !== 'false';
    var minDelay = Number(attr('min-delay')) || 0;
    var kKey = attr('k-key'), kEmail = attr('k-email'), kSms = attr('k-sms');
    var mailOn = attr('mail') === 'true'; // the card may promise the code by email
    var designMode = el.hasAttribute('data-design-mode');
    var st = readState();

    var built = false, step = 'card', revealed = false, opening = false, cssReady = null, logo = null, advance = null;
    var body, card, canvas, face, form, emailIn, telIn, cc, submit, announce;

    function save() { if (!designMode) put(local, KEY_STATE, JSON.stringify(st)); }

    /* ---------- Opening ---------- */
    function loadCss() {
      if (cssReady) return cssReady;
      var href = attr('css');
      cssReady = new Promise(function (resolve) {
        if (!href) { resolve(); return; }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = link.onerror = function () { resolve(); };
        setTimeout(resolve, 2500);
        document.head.appendChild(link);
      });
      return cssReady;
    }
    function loadLogo() {
      if (logo || !attr('logo')) return;
      logo = new Image();
      logo.decoding = 'async';
      logo.onload = function () { if (ctx && canvas && canvas.__ready && !touched && !revealed) paintFoil(); };
      logo.src = attr('logo');
    }

    function show(opener, then) {
      if (opening || el.classList.contains('is-open')) return;
      opening = true;
      loadLogo();
      loadCss().then(function () {
        opening = false;
        build();
        hidePill();
        showStep(revealed || st.step === 'claim' ? 'claim' : 'card', false);
        O.drawer.open(el, opener);
        if (then) then();
        // Wait for layout so the canvas can measure itself
        requestAnimationFrame(function () { requestAnimationFrame(function () { if (step === 'card') { initFoil(); refitFoil(); } }); });
      });
    }

    function build() {
      if (built) return;
      built = true;
      el.appendChild(tpl.content.cloneNode(true));
      body = el.querySelector('[data-welcome-body]');
      card = el.querySelector('[data-card]');
      canvas = el.querySelector('[data-foil]');
      face = el.querySelector('[data-face]');
      form = el.querySelector('[data-welcome-form]');
      emailIn = el.querySelector('input[type="email"]');
      telIn = el.querySelector('[data-phone-input]');
      cc = el.querySelector('[data-cc]');
      submit = el.querySelector('[data-welcome-submit]');
      announce = el.querySelector('[data-announce]');

      el.querySelector('[data-reveal]').addEventListener('click', function () { reveal(true); });
      [emailIn, telIn].forEach(function (input) {
        if (input) input.addEventListener('input', function () { clearError(input); });
      });
      if (cc) cc.addEventListener('change', function () { if (telIn) clearError(telIn); });
      if (form) form.addEventListener('submit', onSubmit);
      var copyBtn = el.querySelector('[data-copy]');
      if (copyBtn) copyBtn.addEventListener('click', onCopy);

      el.addEventListener('drawer:close', onClose);
      window.addEventListener('resize', refitFoil);
    }

    function showStep(name, focus, pop) {
      step = name;
      O.$$('[data-step]', el).forEach(function (s) {
        var on = s.getAttribute('data-step') === name;
        s.hidden = !on;
        s.classList.remove('is-entering');
        // The email step pops in after the reveal (the stylesheet leaves it still with reduced motion)
        if (on && pop) { void s.offsetWidth; s.classList.add('is-entering'); }
      });
      O.$$('[data-autofocus]', el).forEach(function (n) { n.removeAttribute('data-autofocus'); });
      var head = el.querySelector('[data-step="' + name + '"] [data-step-focus]');
      if (head) {
        head.setAttribute('data-autofocus', '');
        el.setAttribute('aria-labelledby', head.id);
      }
      if (body) body.scrollTop = 0;
      if (focus && head) head.focus({ preventScroll: true });
      if (name === 'claim') { clearTimeout(advance); st.step = 'claim'; save(); }
    }

    function onClose() {
      clearTimeout(advance);
      if (step === 'done' || st.done) { settleFocus(); return; }
      // Closed before claiming: shrink to the pill, and never open by itself again for 30 days
      st.step = revealed || step === 'claim' ? 'claim' : 'card';
      st.min = Date.now();
      save();
      if (!designMode) put(local, KEY_CLOSED, String(Date.now()));
      // Focus goes to the pill when it was the way in, or when it would otherwise be left in the closed card
      var a = document.activeElement;
      showPill(el.__opener === pillBtn || !a || a === document.body || el.contains(a));
    }
    // Focus left in the closing card (or on the hidden pill) would drop to the top of the page: put it on the main content
    function settleFocus() {
      var a = document.activeElement;
      if (a && a !== document.body && !el.contains(a) && !(pill && pill.contains(a))) return;
      var main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    }

    /* ---------- The foil ---------- */
    var ctx = null, grid = null, cols = 0, rows = 0, total = 1, cleared = 0, touched = false, foilW = 0, foilH = 0, tries = 0;
    var stroke = null; // the left and right edges the current swipe has reached: {x0, x1}
    // The foil's lettering is Times in spaced capitals, like the card's wordmark (Samantha Holmes type)
    var SERIF = '"Olilu Times", TimesNewRoman, "Times New Roman", Times, Tinos, Georgia, serif';

    function initFoil() {
      if (!canvas || canvas.__ready || revealed) return;
      ctx = canvas.getContext ? canvas.getContext('2d') : null;
      if (!ctx) {
        // No canvas in this browser: show the gift straight away
        if (card) card.classList.add('is-ready');
        reveal(false);
        return;
      }
      var box = canvas.getBoundingClientRect();
      if (!box.width || !box.height) {
        // Not laid out yet: try again on the next frames. A card that measures 0 is never revealed for free.
        if (tries++ < 60 && el.classList.contains('is-open')) requestAnimationFrame(initFoil);
        return;
      }
      tries = 0;
      var first = !canvas.__bound;
      canvas.__ready = true;
      foilW = box.width; foilH = box.height;
      var dpr = Math.min(window.devicePixelRatio || 1, 3);
      canvas.width = Math.round(foilW * dpr);
      canvas.height = Math.round(foilH * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cols = Math.ceil(foilW / CELL);
      rows = Math.ceil(foilH / CELL);
      total = cols * rows;
      grid = new Uint8Array(total);
      cleared = 0;
      touched = false;

      paintFoil();
      card.classList.add('is-ready');
      // On Android the Times face (Tinos) may still be loading the first time: paint again once it is in
      if (document.fonts && document.fonts.load) {
        Promise.race([document.fonts.load('400 14px "Olilu Times"'), wait(1500)]).then(function () { if (!touched && !revealed) paintFoil(); }, function () {});
      }
      if (first) bindFoil();
    }

    // A new width (a rotated phone) repaints a sharp foil, but only before scratching starts: after that the foil keeps
    // its scratches and stretches with the card. A size of 0 (a passing layout, a webview resize) is ignored.
    function refitFoil() {
      if (!canvas || !canvas.__ready || revealed || touched || !el.classList.contains('is-open')) return;
      var w = canvas.getBoundingClientRect().width;
      if (!w || Math.abs(w - foilW) < 1) return; // phone address bars fire resize while scrolling
      canvas.__ready = false;
      initFoil();
    }

    function bindFoil() {
      canvas.__bound = true;
      var down = false, last = null;
      function at(e) {
        var r = canvas.getBoundingClientRect();
        // In the foil's own units, which differ from the screen once the card has been resized mid-scratch
        return { x: (e.clientX - r.left) * (r.width ? foilW / r.width : 1), y: (e.clientY - r.top) * (r.height ? foilH / r.height : 1) };
      }
      canvas.addEventListener('pointerdown', function (e) {
        if (revealed) return;
        // A click on the foil must not move focus out of the card (to <body>, where Tab escapes the dialog)
        if (e.pointerType === 'mouse' && e.cancelable) e.preventDefault();
        down = true;
        last = at(e);
        stroke = { x0: last.x, x1: last.x }; // a new swipe
        scratch(last, last);
        try { canvas.setPointerCapture(e.pointerId); } catch (x) { /* ignore */ }
      });
      canvas.addEventListener('pointermove', function (e) {
        if (revealed) return;
        // A mouse scratches just by moving over the card; touch and pen scratch while pressed
        if (!down && e.pointerType !== 'mouse') return;
        var p = at(e);
        if (!stroke) stroke = { x0: p.x, x1: p.x };
        if (last) scratch(last, p);
        last = p;
      });
      ['pointerup', 'pointercancel'].forEach(function (t) {
        canvas.addEventListener(t, function (e) { down = false; if (e.pointerType !== 'mouse') { last = null; stroke = null; } });
      });
      canvas.addEventListener('pointerleave', function () { down = false; last = null; stroke = null; });
      // A quick flick must not leave a fling behind that swallows the next tap (the x, Tap to reveal)
      ['touchstart', 'touchmove'].forEach(function (t) {
        canvas.addEventListener(t, function (e) { if (!revealed && e.cancelable) e.preventDefault(); }, { passive: false });
      });
    }

    // Draws text one letter at a time so the letter-spacing works in every browser
    function spaced(text, x, y, gap, align) {
      var widths = [], sum = 0, i;
      for (i = 0; i < text.length; i++) { widths.push(ctx.measureText(text[i]).width); sum += widths[i]; }
      sum += gap * (text.length - 1);
      var cx = align === 'center' ? x - sum / 2 : x;
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      for (i = 0; i < text.length; i++) { ctx.fillText(text[i], cx, y); cx += widths[i] + gap; }
      return sum;
    }
    // The spiral O from the logo
    function spiral(cx, cy, size, color, lw) {
      var turns = 2.4, max = turns * Math.PI * 2, a, r;
      ctx.beginPath();
      for (a = 0; a <= max; a += 0.18) {
        r = size * (0.12 + 0.88 * a / max);
        var x = cx + Math.cos(a - Math.PI / 2) * r, y = cy + Math.sin(a - Math.PI / 2) * r;
        if (a) ctx.lineTo(x, y); else ctx.moveTo(x, y);
      }
      ctx.lineWidth = lw;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.strokeStyle = color;
      ctx.stroke();
    }

    function paintFoil() {
      var w = foilW, h = foilH, i, x, y;
      ctx.save();
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, w, h);

      // Brushed silver
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#c3c8cd');
      g.addColorStop(0.2, '#eceef0');
      g.addColorStop(0.42, '#c8cdd1');
      g.addColorStop(0.6, '#f6f7f8');
      g.addColorStop(0.8, '#cbd0d4');
      g.addColorStop(1, '#b4babf');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      for (y = 0; y < h; y += 2) {
        ctx.fillStyle = y % 4 ? 'rgba(255, 255, 255, .26)' : 'rgba(110, 118, 126, .09)';
        ctx.fillRect(0, y, w, 1);
      }

      // Faint diagonal OLILU + spiral watermark
      ctx.save();
      ctx.translate(w / 2, h / 2);
      ctx.rotate(-Math.PI / 9);
      ctx.font = '400 11px ' + SERIF;
      ctx.fillStyle = 'rgba(92, 100, 106, .17)';
      var d = Math.sqrt(w * w + h * h) / 2 + 40;
      for (y = -d, i = 0; y < d; y += 24, i++) {
        for (x = -d + (i % 2) * 48; x < d; x += 96) {
          var tw = spaced('OLILU', x, y, 3, 'left');
          spiral(x + tw + 14, y, 4.6, 'rgba(92, 100, 106, .17)', 1);
        }
      }
      ctx.restore();

      // Dashed inner edge
      ctx.setLineDash([4, 4]);
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(64, 72, 78, .42)';
      ctx.strokeRect(10.5, 10.5, w - 21, h - 21);
      ctx.setLineDash([]);

      // The logo, then SCRATCH HERE
      var lh = Math.round(h * 0.34), cy = h * 0.43;
      if (logo && logo.complete && logo.naturalWidth) {
        var lw = lh * logo.naturalWidth / logo.naturalHeight;
        ctx.drawImage(logo, (w - lw) / 2, cy - lh / 2, lw, lh);
      } else {
        spiral(w / 2, cy, lh * 0.42, 'rgba(14, 88, 120, .9)', 3);
      }
      ctx.font = '400 ' + (w < 330 ? 13 : 15) + 'px ' + SERIF;
      ctx.fillStyle = 'rgba(38, 44, 48, .86)';
      spaced('SCRATCH HERE', w / 2, h * 0.79, w < 330 ? 3.5 : 4.5, 'center');
      ctx.restore();
    }

    function scratch(a, b) {
      touched = true;
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = BRUSH_R * 2;
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x + 0.01, b.y);
      ctx.stroke();
      ctx.restore();
      mark(a, b);
      // A light scratch is enough: a tenth of the foil, or one swipe across half the card (the brush's width counts)
      if (stroke) {
        stroke.x0 = Math.min(stroke.x0, a.x, b.x);
        stroke.x1 = Math.max(stroke.x1, a.x, b.x);
      }
      var reach = stroke ? Math.min(foilW, stroke.x1 + BRUSH_R) - Math.max(0, stroke.x0 - BRUSH_R) : 0;
      if (cleared / total >= CLEAR_AT || reach >= foilW * SPAN_AT) reveal(false);
    }

    // Marks the grid cells under the brush, so no pixel reads are needed (works with the logo from the CDN)
    function mark(a, b) {
      var R = BRUSH_R, dx = b.x - a.x, dy = b.y - a.y;
      var steps = Math.max(1, Math.ceil(Math.sqrt(dx * dx + dy * dy) / 4));
      for (var s = 0; s <= steps; s++) {
        var x = a.x + dx * s / steps, y = a.y + dy * s / steps;
        var c0 = Math.max(0, Math.floor((x - R) / CELL)), c1 = Math.min(cols - 1, Math.floor((x + R) / CELL));
        var r0 = Math.max(0, Math.floor((y - R) / CELL)), r1 = Math.min(rows - 1, Math.floor((y + R) / CELL));
        for (var r = r0; r <= r1; r++) {
          for (var c = c0; c <= c1; c++) {
            var i = r * cols + c;
            if (grid[i]) continue;
            var ox = c * CELL + CELL / 2 - x, oy = r * CELL + CELL / 2 - y;
            if (ox * ox + oy * oy <= R * R) { grid[i] = 1; cleared++; }
          }
        }
      }
    }

    function reveal(byButton) {
      if (revealed) return;
      revealed = true;
      stroke = null;
      if (card) card.classList.add('is-ready', 'is-revealed');
      if (canvas) canvas.classList.add('is-gone'); // fades out fast in the stylesheet (at once with reduced motion)
      if (face) face.removeAttribute('aria-hidden');
      var hint = el.querySelector('[data-hint]');
      var hadFocus = byButton || (document.activeElement && hint && hint.contains(document.activeElement));
      if (hint) hint.classList.add('is-spent'); // keeps its space, so the card doesn't jump under the finger
      if (announce) announce.textContent = 'Unlocked: a gift for you.';
      // "Tap to reveal" is gone: keep focus inside the card until the email step takes it
      if (hadFocus) { var h = el.querySelector('[data-step="card"] [data-step-focus]'); if (h) h.focus({ preventScroll: true }); }
      st.step = 'claim';
      save();
      // "A gift for you" for a moment, then the email step pops up by itself (with reduced motion too, just without the animation)
      advance = setTimeout(function () { if (step === 'card' && el.classList.contains('is-open')) showStep('claim', true, true); }, HOLD_MS);
    }

    /* ---------- Claiming ---------- */
    function errorFor(input) { return input && document.getElementById(input.getAttribute('aria-describedby')); }
    function showError(input, msg) {
      var p = errorFor(input);
      if (p) { p.textContent = msg; p.hidden = false; }
      input.setAttribute('aria-invalid', 'true');
    }
    function clearError(input) {
      var p = errorFor(input);
      if (p && !p.hidden) { p.hidden = true; p.textContent = ''; }
      input.removeAttribute('aria-invalid');
    }

    // Resolves to true when Klaviyo accepted the call (it answers 202), false otherwise. Never rejects: the claim still goes through.
    function klaviyo(path, payload) {
      if (!kKey || !kEmail) return Promise.resolve(false);
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(kKey), {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(payload)
      }).then(function (res) { return !!(res && res.ok); }, function () { return false; });
    }
    function subscribe(attrs, listId) {
      if (!listId) return Promise.resolve(false);
      return klaviyo('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'Olilu scratch card', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: listId } } } } });
    }
    function contact(email, tags, phone) {
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', tags);
      fd.append('contact[accepts_marketing]', 'true');
      if (phone) fd.append('contact[phone]', phone);
      return fetch(rootUrl() + 'contact', { method: 'POST', body: fd, credentials: 'same-origin' });
    }

    function onSubmit(e) {
      e.preventDefault();
      if (submit.classList.contains('is-loading')) return;
      var email = (emailIn.value || '').trim();
      var bad = null;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        showError(emailIn, 'Please enter your email address, for example name@example.com.');
        bad = bad || emailIn;
      }
      var phone = '';
      if (telIn) {
        phone = e164(telIn.value, cc ? cc.value : 'GB');
        if (phone === '' && telIn.required) { showError(telIn, 'Please add your mobile number.'); bad = bad || telIn; }
        else if (phone === null) { showError(telIn, 'Please check your mobile number, for example 07700 900123.'); bad = bad || telIn; }
      }
      if (bad) { bad.focus(); return; }
      emailIn.value = email;

      var code = form.getAttribute('data-code') || '';
      var label = form.getAttribute('data-label') || '';
      // newsletter,welcome-gift,welcome-10 for WELCOME10. Klaviyo sends the welcome email now: any Shopify Email
      // automation on welcome-10 must be switched off once the Klaviyo welcome flow is live (no double welcome).
      var tags = 'newsletter,welcome-gift' + (code ? ',welcome-' + code.toLowerCase().replace(/^welcome-?/, '') : '');
      submit.classList.add('is-loading');
      submit.setAttribute('aria-busy', 'true');

      // 1) Shopify customer with email marketing. Shopify may answer with its bot check ('challenge'), which fetch never
      //    shows the shopper. If it turns the phone number down, try again without it.
      var shop = contact(email, tags, phone).then(function (res) {
        var url = (res && res.url) || '';
        if (/\/challenge/.test(url)) return 'challenge';
        if (/customer_posted=true/.test(url)) return 'ok';
        if (phone) return contact(email, tags, '').then(function (r2) { return /\/challenge/.test((r2 && r2.url) || '') ? 'challenge' : 'ok'; });
        return res && res.ok === false ? 'refused' : 'ok';
      }).catch(function () { return 'offline'; /* not fatal */ });

      if (!kKey || !kEmail) {
        // No Klaviyo yet, so Shopify is the only record of this sign-up: when its bot check steps in, send the form the
        // ordinary way so the shopper can answer it. The code shows when Shopify brings them back.
        Promise.race([shop, wait(6000)]).then(function (r) {
          if (r === 'challenge' || r === 'refused') sendNative(email, tags, code);
          else applyCode(code).then(function () { success(code, email); });
        });
        return;
      }
      var jobs = [shop], mailed = false;
      // 2) Klaviyo (only once its public key and list are set in Theme settings > Klaviyo). Joining the email list starts
      //    the welcome email, which quotes the profile's welcome_code. Only a sign-up Klaviyo accepted gets "Check your inbox".
      jobs.push(subscribe({ email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }, kEmail).then(function (ok) { mailed = ok === true; }));
      if (phone && kSms) jobs.push(subscribe({ email: email, phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } }, kSms));
      jobs.push(klaviyo('profiles', { data: { type: 'profile', attributes: { email: email, properties: { welcome_gift: label, welcome_code: code, signup_source: 'Scratch card' } } } }));
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) { /* ignore */ }
      // 3) Put the code on this browser's checkout
      jobs.push(applyCode(code));
      settle(jobs).then(function () { success(code, email, mailOn && mailed); });
    }

    function applyCode(code) {
      if (!code) return Promise.resolve();
      return settle([fetch(rootUrl() + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(rootUrl() + 'cart.js'), { credentials: 'same-origin' }).catch(function () { /* the code is on screen */ })]);
    }

    // The ordinary form post: Shopify shows its check, then comes back to this page with ?customer_posted=true
    function sendNative(email, tags, code) {
      put(session, KEY_PENDING, JSON.stringify({ code: code, t: Date.now() }));
      var f = document.createElement('form');
      f.method = 'post';
      f.action = rootUrl() + 'contact';
      f.hidden = true;
      [['form_type', 'customer'], ['utf8', '✓'], ['contact[email]', email], ['contact[tags]', tags], ['contact[accepts_marketing]', 'true']].forEach(function (kv) {
        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = kv[0];
        i.value = kv[1];
        f.appendChild(i);
      });
      document.body.appendChild(f);
      f.submit();
    }

    var doneText = '';
    // mailed: the welcome email is switched on and Klaviyo took this sign-up, so "Check your inbox" is true
    function success(code, email, mailed) {
      setCookie(COOKIE, '1', 365);
      drop(local, KEY_CLOSED);
      st = { done: Date.now() };
      save();
      hidePill();
      var c = el.querySelector('[data-welcome-code]');
      if (c && code) c.textContent = code;
      var mailPart = el.querySelector('[data-done-mail]'), plainPart = el.querySelector('[data-done-plain]');
      if (mailed && email && mailPart) {
        // "Your 10% off code is on its way to name@example.com." (textContent: the address is never read as HTML)
        var to = el.querySelector('[data-welcome-to]');
        if (to) to.textContent = email;
        if (plainPart) plainPart.parentNode.removeChild(plainPart);
      } else {
        // No email promise: "Your gift is ready", with the code at full size
        if (mailPart) mailPart.parentNode.removeChild(mailPart);
        if (plainPart) plainPart.hidden = false;
        var box = el.querySelector('[data-code-box]');
        if (box) box.classList.remove('welcome__code-box--small');
      }
      var p = el.querySelector('[data-copied]');
      doneText = p ? p.textContent : '';
      submit.classList.remove('is-loading');
      submit.removeAttribute('aria-busy');
      showStep('done', true, true);
      document.dispatchEvent(new CustomEvent('olilu:welcome-subscribed', { detail: { code: code } }));
    }

    function onCopy() {
      var code = (el.querySelector('[data-welcome-code]').textContent || '').trim();
      var btn = el.querySelector('[data-copy]'), msg = el.querySelector('[data-copied]');
      var done = function () {
        btn.textContent = 'Copied';
        if (msg) msg.textContent = 'Copied ' + code + '. ' + doneText;
        setTimeout(function () { btn.textContent = 'Copy'; }, 2000);
      };
      try {
        if (navigator.clipboard && window.isSecureContext) { navigator.clipboard.writeText(code).then(done, fallback); return; }
      } catch (err) { /* fall through */ }
      fallback();
      function fallback() {
        var t = document.createElement('textarea');
        t.value = code;
        t.setAttribute('readonly', '');
        t.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
        el.appendChild(t);
        t.select();
        try { document.execCommand('copy'); done(); } catch (err) { /* nothing more to do */ }
        el.removeChild(t);
        btn.focus();
      }
    }

    /* ---------- The pill ---------- */
    var bar = document.querySelector('[data-pdp-bar]');
    var pillOn = false, pillTick = false;

    function showPill(focusIt) {
      if (!pill || hasCookie(PILL_OFF) || st.done || hasCookie(COOKIE) && !designMode && !forced) {
        if (focusIt) settleFocus();
        return;
      }
      loadCss().then(function () {
        if (el.classList.contains('is-open') || st.done) return;
        pillOn = true;
        pill.hidden = false;
        coverPill();
        placePill();
        requestAnimationFrame(function () {
          pill.classList.add('is-in');
          if (!focusIt) return;
          // Onto the pill when it can be seen; otherwise (waiting for the product page's bar, under a drawer) the page
          if (!pill.classList.contains('is-tucked') && !pill.classList.contains('is-covered')) pillBtn.focus({ preventScroll: true });
          else settleFocus();
        });
      });
    }
    function hidePill() {
      if (!pill) return;
      pillOn = false;
      pill.classList.remove('is-in');
      pill.hidden = true;
    }
    // On product pages on phones it waits for the add-to-basket bar and sits just above it (never over the title or the
    // colour and size choices); everywhere it steps aside from the add-to-basket button and a chat bubble
    function placePill() {
      pillTick = false;
      if (!pillOn) return;
      var barOn = !!bar && bar.classList.contains('is-visible') && bar.offsetHeight > 0;
      var lift = barOn ? bar.offsetHeight : 0;
      pill.style.setProperty('--wpill-lift', lift + 'px');
      pill.classList.toggle('is-lifted', lift > 0); // the bar already pads for the iPhone home indicator
      var waiting = !!bar && !barOn && getComputedStyle(bar).display !== 'none';
      var p = pill.getBoundingClientRect();
      var hit = waiting || O.$$('.pdp__add, #shopify-chat, inbox-online-store-chat, #ShopifyChat').some(function (n) {
        var r = n.getBoundingClientRect();
        return r.width > 0 && r.bottom > p.top - 6 && r.top < p.bottom + 6 && r.right > p.left - 6 && r.left < p.right + 6;
      });
      pill.classList.toggle('is-tucked', hit);
    }
    function queuePlace() { if (!pillTick) { pillTick = true; requestAnimationFrame(placePill); } }
    // Hidden while the basket, menu, search or any other drawer is open
    function coverPill() {
      if (!pill) return;
      pill.classList.toggle('is-covered', O.$$('.drawer.is-open').some(function (d) { return d !== el; }));
    }

    if (pill) {
      pillBtn.addEventListener('click', function () { show(pillBtn); });
      pill.querySelector('[data-pill-x]').addEventListener('click', function () {
        setCookie(PILL_OFF, '1', 7);
        hidePill();
        var main = document.getElementById('MainContent');
        if (main) main.focus({ preventScroll: true });
      });
      document.addEventListener('drawer:open', function (e) { if (e.target !== el) pill.classList.add('is-covered'); });
      document.addEventListener('drawer:close', function (e) { if (e.target !== el) setTimeout(coverPill, 0); });
      window.addEventListener('scroll', queuePlace, { passive: true });
      window.addEventListener('resize', queuePlace);
      if (bar && window.MutationObserver) {
        new MutationObserver(function () { queuePlace(); setTimeout(queuePlace, 320); }).observe(bar, { attributes: true, attributeFilter: ['class'] });
      }
    }

    /* ---------- When to open ---------- */
    var forced = /[?&]welcome=1(&|#|$)/.test(location.search) || location.hash === '#welcome';
    function forceOpen() {
      // Owner preview: a fresh card whatever the cookies say
      forced = true;
      if (!el.classList.contains('is-open') && !revealed) st = {};
      show();
    }
    window.addEventListener('hashchange', function () { if (location.hash === '#welcome') forceOpen(); });
    document.addEventListener('olilu:welcome-open', function () { show(); });

    if (/^\/challenge/.test(location.pathname)) return; // Shopify's bot check page
    // Back from Shopify's bot check with the sign-up made: straight to the code
    var pending = readPending();
    if (pending && /[?&]customer_posted=true/.test(location.search)) {
      drop(session, KEY_PENDING);
      show(null, function () { applyCode(pending.code); success(pending.code, ''); });
      return;
    }
    if (forced) { forceOpen(); return; }
    if (designMode) return;
    if (Number(cfg.customer) > 0 || hasCookie(COOKIE) || st.done) return;

    var pillAllowed = !!pill && !hasCookie(PILL_OFF);
    if (closedRecently()) {
      // Closed in the last 30 days: the pill is the way back in, the card never opens by itself again
      if (pillAllowed) showPill(false);
      return;
    }
    if (!auto && !pillAllowed) return;

    var secs = 0, want = false, fired = false;
    var views = Number(get(session, KEY_VIEWS)) || 1;
    var exitIntent = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches);

    function busy() {
      var a = document.activeElement;
      if (a && a !== document.body && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
      return O.$$('.drawer.is-open').some(function (d) { return d !== el; });
    }
    function trigger() {
      if (fired) return;
      want = true;
      if (busy()) return; // another drawer is open or someone is typing: try again on the next tick
      fired = true;
      clearInterval(timer);
      document.removeEventListener('mouseout', onExit);
      if (auto) show(); else showPill(false);
    }
    function tick() {
      if (document.visibilityState === 'visible') secs++;
      if (secs < minDelay) return;
      if (want || secs >= 20 || (views >= 2 && secs >= 4)) trigger();
    }
    function onExit(e) {
      if (e.relatedTarget || e.clientY > 0) return;
      if (secs < Math.max(3, minDelay)) return;
      trigger();
    }
    var timer = setInterval(tick, 1000);
    if (exitIntent) document.addEventListener('mouseout', onExit);
  });
})();
